
import * as React from "react";

interface IImageUploadProps {
    label: string
    id: string
    icon: string
    multiple?: boolean

    change: Function
    value: string
}

interface IImageUploadState {
    base64URL: any
}

export default class ImageUpload extends React.Component<IImageUploadProps, IImageUploadState>{

    constructor(props:IImageUploadProps){
        super(props);
        this.state = {
            base64URL: ''
        }
    }

    private ClickHandler(){
        document.getElementById(this.props.id).click();
    }

    private fileChange(e) {
        this.props.change(e.target.files[0]);

        let file = e.target.files[0];

        this.getBase64(file)
            .then(result => {
                file["base64"] = result;
                this.setState({
                    base64URL: result
                });
            })
            .catch(err => {
                console.log(err);
            });
    }

    getBase64 = file => {
        return new Promise(resolve => {
            let baseURL: string | ArrayBuffer = "";
            // Make new FileReader
            let reader = new FileReader();

            // Convert the file to base64 text
            reader.readAsDataURL(file);

            // on reader load somthing...
            reader.onload = () => {
                // Make a fileInfo Object
                baseURL = reader.result;
                resolve(baseURL);
            };
        });
    };


    render() {
       return (
           <div className = "upload_photo_box" onClick = {() => this.ClickHandler()}>
               {
                   this.state.base64URL.length > 0 ?
                       <img style = {{width: '100%'}}  src = {this.state.base64URL} /> :
                       (
                           this.props.value.length > 0 ?
                               <img style = {{width: '100%'}} src = {this.props.value}  alt={""}/> :
                               <>
                                   <p>{this.props.label}</p>
                                   <img src = {this.props.icon}  alt={""}/>
                               </>
                       )
               }

               <input type="file" id={this.props.id} name="file" accept="image/*" required={false} style={{ display: 'none' }} onChange={ e => this.fileChange(e)} />
           </div>

        );
    }
}
